import { hasInheritedRolePermission } from '../utils';

const AuthRoles = ['user', 'super'] as const;
export type AuthRole = (typeof AuthRoles)[number];

/**
 * Omitting External for now
 */
const Roles = [...AuthRoles, 'admin', 'owner'] as const;
export type Role = (typeof Roles)[number];

export const DefaultRole: AuthRole = 'user';

/**
 * Reusable array for forms. To be used in conjunction with select components
 */
export function RoleItems(authUserRole?: Role, omitRoles?: Role[]) {
	// if no auth role is provided, return everything
	if (!authUserRole) {
		return Roles.map((role) => ({
			label: `user.roles.${role}`,
			value: role,
		}));
	}

	return Roles.filter(
		(role) =>
			!omitRoles?.includes(role) &&
			hasInheritedRolePermission(authUserRole, role),
	).map((role) => ({
		label: `user.roles.${role}`,
		value: role,
	}));
}
